module.exports = new Promise(resolve => {
    const script = document.createElement('script')
    script.src = window.mainUrls['MainState']
    if (!script.src) {
      resolve({
        get: (request) => { throw new Error('Module MainState URL not available') },
        init: (arg) => { throw new Error('Module MainState URL not available') }
      })
      return
    }
    script.onload = () => resolve({
      get: (request) => window['MainState'].get(request),
      init: (arg) => {
        try {
          return window['MainState'].init(arg)
        } catch(e) {
          console.warn('remote container already initialized: MainState')
        }
      }
    })
    script.onerror = () => resolve({
      get: (request) => { throw new Error('Module MainState not available') },
      init: (arg) => { throw new Error('Module MainState not available') }
    })
    document.head.appendChild(script);
  });